  var elem = document.querySelector('.guarantees_slider');
  var flkty = new Flickity( elem, {
    // options
    cellAlign: 'center',
    contain: true,
    autoPlay: true,
    wrapAround: true,
    prevNextButtons: false,
    pageDots: false,
    autoPlay: 3000
  });